import React from 'react';
import { useTranslation } from 'react-i18next';

export default function WelcomeModal({
  visible,
  sportEmoji,
  subtitle,
  startLabel,
  onStart,
  onSkip
}) {
  const { t } = useTranslation('onboarding');
  const resolvedStartLabel = startLabel ?? t('welcomeStartSetup');

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 20000,
        background: 'rgba(13,13,26,0.92)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 16,
          padding: '32px 28px',
          maxWidth: 400,
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 16px 48px rgba(26,35,126,0.2)'
        }}
      >
        <div style={{ fontSize: 48, marginBottom: 12 }}>{sportEmoji}</div>
        <h2 style={{ margin: '0 0 12px', color: '#0d0d1a', fontSize: 22 }}>{t('welcomeTitle')}</h2>
        <p style={{ color: '#616161', lineHeight: 1.5, fontSize: 14, marginBottom: 24 }}>
          {subtitle}
        </p>
        <button
          type="button"
          onClick={onStart}
          style={{
            width: '100%',
            padding: '12px 20px',
            background: '#EB3333',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontSize: 15,
            cursor: 'pointer',
            marginBottom: 10
          }}
        >
          {resolvedStartLabel}
        </button>
        <button
          type="button"
          onClick={onSkip}
          style={{
            background: 'none',
            border: 'none',
            color: '#9e9e9e',
            fontSize: 14,
            cursor: 'pointer'
          }}
        >
          {t('skip')}
        </button>
      </div>
    </div>
  );
}
